export const version = '4.0.0-beta.15'